import { Typography } from "@mui/material";

function NotFound() {
    return <>
        <Typography variant="h4">Page Not Found</Typography>
    </>;
}


export default NotFound;